import React from 'react'
import _ from 'lodash'
import m from 'moment'
import { compose, withHandlers } from 'recompose'
import { renderOptions, toOptions } from '../../../modules/options'

const days = _.range(1, 32, 1)
const monthNames = m.months()
const currentYear = m().get('year')
const years = _.range(currentYear + 30, currentYear - 30, -1)

const dateOptions = {
  days: toOptions(days),
  months: toOptions(monthNames, (monthName, index) => ({
    title: monthName,
    value: index,
  })),
  years: toOptions(years),
}

const DatePicker = ({ value, handleChange }) => {
  const dateValue = m(value)
  return (
    <div className="field is-grouped">
      <div className="control">
        <div className="select is-primary is-small">
          <select
            value={dateValue.get('date')}
            onChange={handleChange}
            name="day"
          >
            {renderOptions(dateOptions.days)}
          </select>
        </div>
      </div>
      <div className="control">
        <div className="select is-primary is-small">
          <select
            value={dateValue.get('month')}
            onChange={handleChange}
            name="month"
          >
            {renderOptions(dateOptions.months)}
          </select>
        </div>
      </div>
      <div className="control">
        <div className="select is-primary is-small">
          <select
            value={dateValue.get('year')}
            onChange={handleChange}
            name="year"
          >
            {renderOptions(dateOptions.years)}
          </select>
        </div>
      </div>
    </div>
  )
}

function updatedDate(currentDate, updatePath, value) {
  const newDate = currentDate.clone()
  switch (updatePath) {
    case 'day':
      const lastDateOfMonth = newDate
        .clone()
        .add('months', 1)
        .date(0)
        .get('date')
      if (value > lastDateOfMonth) {
        return newDate.date(lastDateOfMonth)
      }
      return newDate.date(value)
    case 'month':
      return newDate.month(value)
    case 'year':
      return newDate.year(value)
    default:
      return undefined
  }
}

export default compose(
  withHandlers({
    handleChange: ({ value, onChange }) => e => {
      onChange(updatedDate(value, e.target.name, e.target.value))
    },
  }),
)(DatePicker)



// WEBPACK FOOTER //
// ./src/components/templates/dateTimePicker/DatePicker.js